import React from 'react';
import axios from 'axios';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import ClusterCard from './cluster_card.jsx';

import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  root: {
    height: '100%',
    width: '100%',
    overflowX: 'hidden',
    scrollX: 'none',

  },
  gridContainer: {
      paddingTop: 15,
  },
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});

class VideoClusterInfo extends React.Component {
    state = {
        clusters: {},
        loading: true,
    }

    componentDidMount() {
        const { video } = this.props;

        console.log("VID",video);
        axios.get(`${process.env.REACT_APP_API_URL}/api/video/${video.pk}/clusters`)
            .then(res => {
                const clusters = res.data;

                this.setState({ clusters, loading: false });
            })
    }

    render() {
      const { classes, video } = this.props;
      const { clusters } = this.state;

      return (
        <Paper className={classes.root}>
          <AppBar position="static">
            <Typography variant="title" color="inherit">Facial Groupings</Typography>
          </AppBar>
          <div>
            <Grid container className={classes.gridContainer} spacing={16}>
                {clusters && Object.keys(clusters).length > 0 && Object.keys(clusters).map((cluster, i) => (
                    <Grid item key={i}>
                        <ClusterCard video={video} cluster={clusters[cluster]} />
                    </Grid>
                ))}
            </Grid>
          </div>
        </Paper>
      );
    }
}

VideoClusterInfo.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(VideoClusterInfo);



// WEBPACK FOOTER //
// ./src/components/video_cluster_info.jsx